import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-工业应用开发",
  "use": "icon-工业应用开发-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-工业应用开发\">\r\n<g>\r\n\t<path d=\"M157.8,74.3c-2.2-2.9-6.4-3.6-9.4-1.4L119.4,94c-0.8,0.5-1.9,0.6-2.7,0.1L85.5,74.8C81,72,75,72.3,70.8,75.6l-24.4,19\r\n\t\tc-2.8,2.3-3.4,6.6-1,9.5c2.2,2.9,6.5,3.4,9.3,1.2l22.7-17.7c0.8-0.6,1.9-0.7,2.8-0.2l31.1,19.1c2.1,1.3,4.5,1.9,6.8,1.9\r\n\t\tc2.7,0,5.3-0.8,7.6-2.5l30.7-22.3C159.4,81.6,160.1,77.4,157.8,74.3L157.8,74.3z\" />\r\n\t<path d=\"M155.5,173.4h-111c-3.8,0-6.8,3-6.8,6.8s3,6.8,6.8,6.8h111.1c3.8,0,6.8-3,6.8-6.8S159.3,173.4,155.5,173.4z\" />\r\n\t<path d=\"M167.9,13H32.1C21.6,13,13,21.6,13,32.1v111.1c0,10.5,8.6,19.1,19.1,19.1h135.7c10.5,0,19.1-8.6,19.1-19.1V32.1\r\n\t\tC187,21.6,178.4,13,167.9,13z M173.4,143.3c-0.1,3-2.6,5.5-5.6,5.5H32c-3-0.1-5.5-2.6-5.5-5.6V32c0.1-3,2.6-5.5,5.6-5.5H168\r\n\t\tc3,0.1,5.5,2.6,5.5,5.6V143.3z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/工业应用开发.svg
// module id = PZyJ
// module chunks = 15